import React from 'react';

const PrivacyPolicy1 = () => {
  return (
    <div className="container mx-auto px-4 py-40">
      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>

      <h2 className="text-2xl font-semibold mb-4">1. Introduction</h2>
      <p className="mb-4">
        Welcome to Urban Pick ("we," "our," "us"). We are committed to protecting your privacy and ensuring that your personal information is handled securely and responsibly. This Privacy Policy outlines how we collect, use, and protect information when you use our app.
      </p>

      <h2 className="text-2xl font-semibold mb-4">2. Information We Collect</h2>
      <p className="mb-2">We collect and process the following types of data:</p>

      <h3 className="text-xl font-medium mb-2">2.1 Data Provided by Merchants</h3>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li><strong>Shop Information:</strong> Store name, store URL, and Shopify Admin data necessary for app functionality.</li>
        <li><strong>City List Data:</strong> Cities configured in Shopify Admin for checkout dropdown functionality.</li>
      </ul>

      <h3 className="text-xl font-medium mb-2">2.2 Data Collected Automatically</h3>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li><strong>Checkout Interaction Data:</strong> Non-personally identifiable information about city selections at checkout.</li>
        <li><strong>Technical Data:</strong> Logs and diagnostics for app performance monitoring.</li>
      </ul>

      <h2 className="text-2xl font-semibold mb-4">3. How We Use the Collected Data</h2>
      <p className="mb-4">We use the collected data for the following purposes:</p>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>To dynamically sync and display city dropdown options based on the selected country.</li>
        <li>To improve app performance and provide technical support.</li>
        <li>To ensure a seamless checkout experience by reducing errors related to manual city entries.</li>
      </ul>

      <h2 className="text-2xl font-semibold mb-4">4. Data Sharing and Disclosure</h2>
      <p className="mb-4">
        We do not sell, trade, or share your personal or store data with third parties, except in the following circumstances:
      </p>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li><strong>Legal Compliance:</strong> If required by law, we may disclose information to authorities.</li>
        <li><strong>App Functionality:</strong> Data is shared with Shopify's infrastructure to enable smooth integration with your store.</li>
      </ul>

      <h2 className="text-2xl font-semibold mb-4">5. Data Retention</h2>
      <p className="mb-4">
        We retain city list data and checkout interaction data as long as the app is installed. Upon uninstallation, we automatically delete all associated data from our system.
      </p>

      <h2 className="text-2xl font-semibold mb-4">6. Data Security</h2>
      <p className="mb-4">
        We implement industry-standard security measures to protect your data, including encryption, access controls, and secure storage.
      </p>

      <h2 className="text-2xl font-semibold mb-4">7. Merchant Rights</h2>
      <p className="mb-2">You have the following rights regarding your data:</p>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li><strong>Access:</strong> Request access to the data collected about your store.</li>
        <li><strong>Deletion:</strong> Request deletion of your data if the app is uninstalled.</li>
        <li><strong>Correction:</strong> Update any incorrect store-related information.</li>
      </ul>
      <p className="mb-4">For any requests, contact us at <a href="mailto:basit@mean3.com" className="text-blue-500 hover:underline">basit@mean3.com</a>.</p>

      <h2 className="text-2xl font-semibold mb-4">8. Third-Party Services</h2>
      <p className="mb-4">
        This app integrates with Shopify's API and Metaobjects to function. Shopify’s privacy policy governs the data handled by their platform.
      </p>

      <h2 className="text-2xl font-semibold mb-4">9. Changes to This Policy</h2>
      <p className="mb-4">
        We may update this policy from time to time. If significant changes occur, we will notify users through Shopify or email.
      </p>

      <h2 className="text-2xl font-semibold mb-4">10. Contact Information</h2>
      <p className="mb-2">For questions or concerns about this Privacy Policy, contact us at:</p>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li><strong>Support Email:</strong> <a href="mailto:basit@mean3.com" className="text-blue-500 hover:underline">basit@mean3.com</a></li>
      </ul>
      <p className="mb-4">By using UrbanPick, you agree to the terms outlined in this Privacy Policy.</p>
    </div>
  );
};

export default PrivacyPolicy1;
